"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountBalance = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsAccount_1 = require("../../model/hsAccount");
var service_1 = require("../../../library/base/service");
var AccountBalance = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(AccountBalance, _super);
    function AccountBalance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '余额初始化接口';
        _this.code = '105038';
        _this.desc = '余额初始化接口';
        _this.requestParams = new hsAccount_1.AccountBalanceRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return AccountBalance;
}(service_1.BaseService));
exports.AccountBalance = AccountBalance;
//# sourceMappingURL=accountBalance.js.map